<template>
  <div class="website-develop">
    <div class="title">
      <!-- <vue-seamless-scroll
        style="width:100%"
        :data="dataTitle"
        :class-option="classOption"
      >
        <div
          style="display:flex;overflow: hidden;align-items: center;"
          v-for="(item, i) in dataTitle"
          :key="i"
        >
          <div class="en">{{ item.en }}</div>
          <div class="zh">{{ item.zh }}.</div>
        </div>
      </vue-seamless-scroll> -->
      <marquee-text :duration="20">
        <div class="title-in">
          <div class="en">{{ dataInfo.tips }}</div>
          <div class="zh">{{ dataInfo.name }}</div>
        </div>
      </marquee-text>
    </div>
    <div class="content">
      <vue-seamless-scroll
        style="width:100%"
        :data="dataList"
        :class-option="classOption2"
      >
        <div class="items">
          <div class="item" @click="toLink" v-for="el in dataList" :key="el.id">
            <div class="item-tit">
              <div class="zh">{{ el.title }}</div>
              <div class="en">YEAR</div>
            </div>
            <div
              class="item-con"
              v-for="(data, j) in JSON.parse(el.content)"
              :key="j"
            >
              <div class="month">
                {{ data.month }}
              </div>
              <div style="width:690px">
                <div class="txt" v-for="(tt, k) in data.content" :key="k">
                  ·{{ tt.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";
import vueSeamlessScroll from "vue-seamless-scroll";
import MarqueeText from "vue-marquee-text-component";
import Swiper from "swiper/swiper-bundle";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataTitle: [{ en: "development path ", zh: "发展历程" }],
      classOption: {
        limitMoveNum: 1,
        step: 1.5,
        direction: 3,
        hoverStop: false
      },
      classOption2: {
        limitMoveNum: 1,
        step: 1.5,
        direction: 2,
        hoverStop: false
      },
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: { vueSeamlessScroll, MarqueeText },
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;

    this.$nextTick(() => {
      this.UserSwiper();
    });
  },
  methods: {
    UserSwiper() {
      new Swiper("#swiper", {
        loop: true,
        autoplay: true
      });
    },
    toLink() {
      if (
        this.dataInfo.correlationMenuId &&
        this.dataInfo.correlationPageType
      ) {
        this.toMenu(
          this.dataInfo.correlationPageType,
          this.dataInfo.correlationMenuId
        );
      }
    }
  }
};
</script>
<style lang="less">
.website-develop {
  .title {
    display: flex;
    align-items: center;
    padding-top: 90px;
    padding-bottom: 60px;
    background: #002fa7;
    overflow: hidden;
    // height: 420px;
    box-sizing: border-box;
    &-in {
      display: flex;
      align-items: center;
    }
    .en {
      font-size: 180px;
      font-family: "en-tit";
      color: rgba(255, 255, 255, 0);
      -webkit-text-stroke: 1px #fff;
      text-stroke: 1px #fff;
      line-height: 288px;
    }
    .zh {
      padding-left: 60px;
      padding-right: 60px;
      font-size: 140px;
      font-family: "dream";
      color: #fff;
      line-height: 227px;
    }
  }
  .content {
    padding: 80px 76px 60px;
    background: #003fa7;
    overflow: hidden;
    .items {
      display: flex;
      .item {
        width: 750px;
        margin-right: 30px;
        &-tit {
          display: flex;
          align-items: flex-end;
          padding-bottom: 36px;

          .en {
            padding-left: 16px;
            font-size: 40px;
            font-family: "en-tit";
            color: rgba(255, 255, 255, 0);
            line-height: 48px;
            -webkit-text-stroke: 1px #fff;
            text-stroke: 1px #fff;
          }
          .zh {
            font-size: 60px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #ffffff;
            line-height: 70px;
          }
        }
        &-con {
          margin-bottom: 13px;
          display: flex;
          align-items: flex-start;
          color: #fff;
          .month {
            margin-right: 16px;
            font-size: 24px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #fff;
            width: 55px;
          }
          .txt {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
